var _style, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGearRaysIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 68.5 44.5",
    style: {
      enableBackground: "new 0 0 68.5 44.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#9DCEC9;}\n\t.st1{clip-path:url(#SVGID_00000087398303301386232200000014574088710673013655_);fill:none;stroke:#9DCEC9;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.5,26.7c-0.2-0.5-0.4-1.1-0.7-1.6s-0.6-1-0.9-1.5c-0.1-0.2-0.3-0.2-0.5-0.2l-1.7,0.7c-0.2,0.1-0.4,0-0.5-0.1 c-0.7-0.8-1.4-1.4-2.3-2c-0.2-0.1-0.2-0.3-0.2-0.4l0.7-1.7c0.1-0.2,0-0.4-0.2-0.4c-1-0.5-2.2-0.9-3.3-1.2c-0.2,0-0.4,0.1-0.5,0.3 l-0.7,1.7c-0.1,0.2-0.2,0.3-0.4,0.3c-1-0.1-2-0.1-3.1,0.2c-0.2,0-0.4,0-0.4-0.2L32.4,19c-0.1-0.2-0.3-0.3-0.5-0.2 c-1.1,0.4-2.2,0.8-3.3,1.4c-0.2,0.1-0.2,0.3-0.1,0.4l0.7,1.6c0.1,0.2,0,0.4-0.1,0.4c-0.8,0.6-1.5,1.3-2,2.2 c-0.1,0.2-0.3,0.2-0.5,0.2l-1.8-0.6c-0.2-0.1-0.4,0-0.5,0.2c-0.6,1-1,2.1-1.2,3.2c0,0.2,0.1,0.4,0.3,0.4l1.8,0.6 c0.2,0.1,0.3,0.2,0.3,0.4c-0.1,1-0.1,2,0.2,2.9c0,0.2,0,0.4-0.2,0.4l-1.8,0.6c-0.2,0.1-0.3,0.3-0.2,0.4c0.4,1.1,0.8,2.1,1.5,3.1 c0.1,0.2,0.3,0.2,0.5,0.1l1.7-0.7c0.2-0.1,0.4,0,0.5,0.1c0.7,0.8,1.4,1.4,2.3,2c0.2,0.1,0.2,0.3,0.2,0.4l-0.7,1.7 c-0.1,0.2,0,0.4,0.2,0.4c1,0.5,2.2,0.9,3.3,1.2c0.2,0,0.4-0.1,0.5-0.3l0.7-1.7c0.1-0.2,0.2-0.3,0.4-0.3c1,0.1,2,0.1,3.1-0.2 c0.2,0,0.4,0,0.4,0.2l0.7,1.6c0.1,0.2,0.3,0.3,0.5,0.2c1.1-0.4,2.2-0.8,3.3-1.4c0.2-0.1,0.2-0.3,0.1-0.4l-0.7-1.6 c-0.1-0.2,0-0.4,0.1-0.4c0.8-0.6,1.5-1.3,2-2.2c0.1-0.2,0.3-0.2,0.5-0.2l1.8,0.6c0.2,0.1,0.4,0,0.5-0.2c0.6-1,0.9-2.1,1.2-3.2 c0-0.2-0.1-0.4-0.3-0.4l-1.8-0.6c-0.2-0.1-0.3-0.2-0.3-0.4c0.1-1,0.1-2-0.2-2.9c0-0.2,0-0.4,0.2-0.4l1.7-0.7 C47.4,27,47.5,26.8,47.5,26.7z M42.2,27.2c1.8,3.5,0.2,7.8-3.5,9.4c-3.6,1.7-8.1,0.2-9.8-3.4c-1.8-3.5-0.2-7.8,3.5-9.4 C36.2,22.2,40.5,23.7,42.2,27.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -5.3,
    y: -8.2,
    transform: "matrix(0.3597 -0.9331 0.9331 0.3597 -6.9455 50.1877)",
    width: 76.8,
    height: 76.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000116939054007339998380000011577621112468966807_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000116939054007339998380000011577621112468966807_)",
      fill: "none",
      stroke: "#9DCEC9",
      strokeMiterlimit: 10
    },
    d: " M9,15.5l1.1,0.8l11.3,7.1 M63.7,29.2l-14.8,0.2 M21.5,29.9L6.1,30.1 M28.6,15.2L23.7,3 M43.3,1.9L40.4,15 M59.6,12l-10.8,9.8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGearRaysIcon);
export default __webpack_public_path__ + "static/media/gear-rays-icon.d4ad8f4116924c90efbac45c1d34524c.svg";
export { ForwardRef as ReactComponent };